<!-- NOTE: id=reptile-tilelist-bracket is still used by Darwin -->
<script lang="ts">
    import { untrack } from 'svelte';
    import { injectWiring } from '@tilelist/application/wiring/TileListWiringContext.svelte.ts';

    const wiring = injectWiring();

    $effect(() => {
        const trackingService = wiring.trackingService;
        if (!trackingService) return;
        untrack(() => {
            trackingService.trackPageCluster('Fehler');
        });
    });
</script>

<div id="reptile-tilelist-bracket" data-origin="dundee">
    <div class="reptile-tilelist-bracket__header">
        <span class="oc-headline-50">Wartungsarbeiten</span>
        <span class="oc-headline-200">Wir sind gleich wieder da.</span>
    </div>
    <div class="reptile-tilelist-bracket__image">
        <img
            src="https:/*                                                                                */
            alt="Error Illustration"
        />
    </div>
</div>

<style lang="scss">
    @use '@otto-ec/design-tokens/tokens';

    #reptile-tilelist-bracket {
        background-color: tokens.$oc-semantic-color-hint-25;
    }

    .reptile-tilelist-bracket {
        &__header {
            display: flex;
            flex-direction: column;
            height: 72px;
            padding: tokens.$oc-semantic-spacing-100 tokens.$oc-semantic-spacing-100 tokens.$oc-semantic-spacing-50;
        }

        &__image {
            padding: tokens.$oc-semantic-spacing-50;

            img {
                aspect-ratio: 4 / 3;
                width: 100%;
                object-fit: cover;
            }
        }
    }
</style>
